
const global={
    app:null,
    pageScale:1,
    userInfo:null,
    screenDirectionIsLandscape:true,
    isMobile:false,
};
export default  global;
export const PUBLIC_URL=`${window.location.origin}${window.location.pathname}`;
export const NODE_ENV=process.env.NODE_ENV;
export const defaultAnimationName="All Animations";
export const onResizeEventName="resize";//'onorientationchange' in window ? 'orientationchange' : 'resize';
export const defaultTaskId=2;
export function getPageSize(size){
    return global.pageScale*size;
}
export function getFullPath(src){
    return `${PUBLIC_URL}${src}`;
}
export function stringSubstring(str,length,replenish="..."){
    str=str||"";
    if(typeof str!=='string')return str.toString();
    if(str.length<length)return str;
    return  str.slice(0,length)+replenish;
}
export function isLandscape(){
    return window.innerWidth/window.innerHeight>1;
    //return Math.abs(window.orientation) === 90|| window.orientation===undefined;
}

export function isPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}
export function arrayGroup(data, size) {
    return Array.from(
        Array((data.length + size - 1) / size | 0),
        (_, i) => data.slice(i * size, i * size + size)
    );
}
export function deviceIsMobile(){
    const userAgent = navigator.userAgent;

    // 正则表达式检测Mobile关键字
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    global.isMobile=isMobile;
    return isMobile;
}
deviceIsMobile()
export function screenDirectionIsLandscape(){
    let screen=window.screen;
    let currentOrientation = (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;
    window.$screenWidth=window.innerWidth;
    window.$screenHeight=window.innerHeight;
    currentOrientation=false;
    if (!currentOrientation) {
        let d=window.innerWidth > window.innerHeight;
        global.screenDirectionIsLandscape=d;
        return d;
    }
    if (currentOrientation.includes('portrait')) {
        console.log('这是竖屏模式');
        // 执行竖屏模式下的特定操作
        // 例如：调整布局，显示或隐藏某些元素等
        global.screenDirectionIsLandscape=false;
        return global.screenDirectionIsLandscape;
    } else if (currentOrientation.includes('landscape')) {
        console.log('这是横屏模式');
        global.screenDirectionIsLandscape=true;
        return  global.screenDirectionIsLandscape;
        // 执行横屏模式下的特定操作
        // 例如：调整布局，显示或隐藏某些元素等
    }
}
screenDirectionIsLandscape();
//计算全局的缩放单位
export const computeSize=(n=0)=>n*global.pageScale;
//获取随机值
export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
//获取随机颜色
export function getRandomHexColor() {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    return `#${randomColor.padStart(6, '0')}`;
}
export function isDev(){
    return NODE_ENV === "development";
}
export const DateFormat={
    date:'YYYY-MM-DD HH:mm:ss'
}
